import React from 'react';

const ScreenContainer = ({ children, title }) => (
  <div className="pt-4 container-fluid">
    {title !== undefined ? (
      <>
        <h3>{title}</h3>
        <br />
      </>
    ) : null}
    {children}
  </div>
);

export default ScreenContainer;
